module.exports = __webpack_public_path__ + "img/right-arrow.6a30c71a.svg";